<template>
  <div>
    <div class="katta">
      <span>{{ $t("Шифокор кўриги") }}</span>
      <button
        style="padding: 4px 10px; margin-right: 10px"
        class="btn"
        @click="Prev()"
      >
        <b-icon style="color: white" icon="house-door-fill"> </b-icon>
      </button>
    </div>
    <div>
      <div class="oyna1">
        <div class="ustun">
          <div>
            <span>
              <span class="shirift">{{ $t("Кўриг номи") }}</span>
              <span style="color: red;">*</span>
              <span v-if="errors !== null">
                <span
                  style="color: red; font-size: 9px"
                  v-if="!errors.name.required"
                  >{{ $t("Кўриг номи тўлдирилиши керак") }}</span
                >
                <span
                  style="color: red; font-size: 9px"
                  v-if="!errors.name.minLength"
                  >{{ $t("Кўриг номида камида 3 та белги бўлиши керак") }}</span
                >
              </span>
            </span>
            <b-input
              id="shifokorBolimi-name"
              style="background: #fff; border: 1px solid #ced4da;"
              v-model="modelvue.name"
              type="text"
            />
          </div>

          <div>
            <span>
              <span class="shirift">
                {{ $t("Фуқаролик нарҳ") }}
              </span>
              <span v-if="errors !== null">
                <span
                  style="color: red; font-size: 9px"
                  v-if="!errors.price.minLength"
                  >{{ $t("Нарҳида камида 3 та белги бўлиши керак") }}</span
                >
              </span>
            </span>
            <vue-numeric
              style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 5px;"
              v-model="modelvue.price"
              separator="space"
              :precision="2"
            ></vue-numeric>
          </div>
        </div>
        <div class="ustun">
          <div>
            <span>
              <span class="shirift">{{ $t("Шифокор бўлимлари") }}</span>
              <span style="color: red;">*</span>
              <span v-if="errors !== null">
                <span
                  style="color: red; font-size: 9px"
                  v-if="!errors.name.required"
                  >{{ $t("Бўлим номи тўлдирилиши керак") }}</span
                >
                <span
                  style="color: red; font-size: 9px"
                  v-if="!errors.bolim_id.required"
                  >{{ $t("Шифокор бўлими тўлдирилиши керак") }}</span
                >
              </span>
            </span>
            <v-select
              :options="category"
              label="name"
              :reduce="option => option.id"
              v-model="modelvue.bolim_id"
            />
          </div>

          <div>
            <span>
              <span class="shirift">
                {{ $t("Фуқаролиги бўлмаган нарҳ") }}
              </span>
            </span>
            <vue-numeric
              style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 5px;"
              v-model="modelvue.citizen_price"
              separator="space"
              :precision="2"
            ></vue-numeric>
          </div>
          
          <!-- <div>
            <span>
              <span class="shirift">{{ "Харажат" }}</span>
            </span>
            <v-select
              :options="RasxodType"
              @input="ChangeReagentType"
              label="name"
              :reduce="option => option.id"
              v-model="modelvue.rastod_type"
            />
          </div>
          <div v-if="!modelvue.rastod_type">
            <span>
              <span class="shirift">{{ "Вайлута" }}</span>
            </span>
            <v-select
              :options="valuta"
              label="name"
              :reduce="option => option.id"
              v-model="modelvue.currency_type"
            />
          </div>
          <div v-if="!modelvue.rastod_type">
            <span>
              <span class="shirift">
                {{ $t("Сумма") }}
              </span>
            </span>
            <vue-numeric
              style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 5px;"
              v-model="modelvue.rasxod_summa"
              separator="space"
              :precision="2"
            ></vue-numeric>
          </div>
          <div v-if="modelvue.rastod_type" class="table-reagent mt-4">
            <div style="width: 100%;">
              <div
                class="mr-1"
                style="width: 100%; display: flex; padding: 2px; border-bottom: 1px solid #ccc;"
                v-for="(itemR, indR) in modelvue.reagents"
                :key="indR"
              >
                <div
                  class="mr-1"
                  style="width: calc(100% - 135px); padding: 2px 0;"
                >
                  <v-select
                    style="height: 30px !important;"
                    label="name"
                    :options="reagent"
                    v-model="itemR.reagent_id"
                    :reduce="option => option.id"
                  />
                </div>
                <div class="mr-1" style="width: 100px; padding: 2px 0;">
                  <vue-numeric
                    style="width: 100%; height: 30px; border: 1px solid #bdb2b2; border-radius: 5px;"
                    v-model="itemR.count"
                    separator="space"
                    :precision="2"
                  ></vue-numeric>
                </div>
                <div style="width: 35px; padding: 2px 0;">
                  <b-button
                    class="trash1"
                    @click="deleteReagent(indR)"
                    style="width: 30px; height: 30px;"
                    variant="outline-danger"
                  >
                    <b-icon
                      style="width: 10px;"
                      icon="trash-fill"
                      aria-hidden="true"
                    ></b-icon>
                  </b-button>
                </div>
              </div>
            </div>

            <div>
              <b-button
                class="add-btn"
                variant="primary"
                type="number"
                @click="AddReagent"
              >
                <b-icon icon="plus" font-scale="1.5" color="#fff"></b-icon>
              </b-button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shifokorBolimi-form",
  props: ["modelvue", "errors"],
  data() {
    return {
      category: [],
      reagent: [],
      RasxodType: [
        { id: 0, name: "Сумма" }
        // {id: 1, name: "Махсулот"}
      ],
      valuta: [
        { id: 0, name: "UZS" },
        { id: 1, name: "USD" }
      ]
    };
  },
  methods: {
    Prev() {
      this.$router.push("/shifokor-bolimi");
    },
    ChangeReagentType(val) {
      if (val) {
        this.modelvue.currency_type = 0;
        this.modelvue.rasxod_summa = 0;
      } else {
        this.modelvue.reagents = [];
      }
    },
    AddReagent() {
      this.modelvue.reagents.push({
        reagent_id: null,
        count: 0,
        type: "doctor"
      });
    },
    deleteReagent(indR) {
      this.modelvue.reagents.splice(indR, 1);
    },
    ChangeReagent(value) {
      this.reagent.forEach(el => {
        if (value == el.id) {
          this.modelvue.reagent.push(el);
        }
      });
    },
    getReagent() {
      let self = this;
      axios({
        method: "get",
        url: "/reagent/all"
      }).then(res => {
        if (res) {
          self.reagent = res.data.data;
        }
      });
    },
    getBolim() {
      let s = this;
      axios({
        method: "get",
        url: "/bolim/all"
      }).then(res => {
        if (res) {
          s.category = res.data.data;
          // s.totalRows = s.items.length;
        }
      });
    }
  },
  mounted() {
    this.getBolim();
    this.getReagent();
  }
};
</script>
<style>
.table-reagent {
  position: relative;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 7px;
  overflow: auto;
  height: 150px;
}
.add-btn {
  background: #195fb0;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #195fb0;
  box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
  position: relative;
  left: calc(100% - 50px);
  top: calc(100% - 40px);
  width: 30px;
  height: 30px;
}
.katta {
  background: #007bff;
  margin-top: -25px;
  height: 40px;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  line-height: 40px;
  border-radius: 8px;
  color: #fff;
  text-indent: 15px;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.5);
}
.trash1 {
  background: #fff;
  width: 30px;
  height: 30px;
  display: flex;
  border: 1px solid #fadddd;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.select_btn {
  position: relative;
}
.oyna1 {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
.shirift {
  font-size: 16px;
}
.ustun {
  width: 49%;
}
</style>
